import {
    useEffect,
    useState,
    type FC
} from "react";
import {
    ActivityIndicator,
    Image,
    View
} from "react-native";
import type {
    PositionEditCardProps
} from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    SelectBox,
    Text
} from "ncore-ui-kit";
import type {
    PositionsObjectType
} from "../../../../../services/restAPI/actions/getPositions/types";
import type {
    SendProfileUpdateRequestRequestType
} from "../../../../../services/restAPI/actions/sendProfileUpdateRequest/types";
import {
    RESTService
} from "../../../../../services/restAPI";

const PositionCard: FC<PositionEditCardProps> = ({
    companyLogo,
    companyTitle,
    initialPosition,
    companyID,
    setUpdateParams,
    updateParams,
    isEdit,
    disabled,
    objectIndex
}) => {
    const {
        spaces,
        colors,
        radiuses
    } = NCoreUIKitTheme.useContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const [positionData,
        setPositionData] = useState<Array<PositionsObjectType>>([]);
    const [loading,
        setLoading] = useState(true);

    useEffect(() => {
        getPositions();
    }, []);

    const initialPositionUpdated = initialPosition;

    const getPositions = () => {
        RESTService.action("GetPositions", null)
            .then((res) => {

                if(res.code === 200 || res.code === 201 || res.code === 202) {
                    setPositionData(res.payload);

                    if(isEdit) {
                        const _initialValue = res.payload.find(e => e._id === initialPositionUpdated._id);

                        if(_initialValue) {
                            initialPositionUpdated.value = _initialValue.value;
                        }
                    }
                }

                setLoading(false);
            }).catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };

    if(loading) {
        return <View>
            <ActivityIndicator
                size="large"
                color={colors.content.icon.default}
            />
        </View>;
    }

    return <View
        style={[
            stylesheet.container,
            {
                marginTop: objectIndex === 0 ? 0 :  spaces.spacingMd
            }
        ]}
    >

        <Image
            source={{
                uri: companyLogo
            }}
            resizeMode="cover"
            style={[
                stylesheet.companyLogo,
                {
                    borderRadius: radiuses.xs,
                    marginRight: spaces.spacingMd
                }
            ]}
        />
        <View
            style={stylesheet.contentContainer}
        >
            <Text
                variant="titleSmallSize"
                color="high"
                style={{
                    marginBottom: spaces.spacingSm
                }}
            >
                {companyTitle}{isEdit === true ? localize("underReview") : "" }
            </Text>
            <SelectBox
                initialSelectedItems={[
                    {
                        __title: initialPositionUpdated.value,
                        __key: initialPositionUpdated._id
                    }
                ]}
                keyExtractor={(item) => item._id }
                titleExtractor={(item) => item.value}
                spreadBehaviour="stretch"
                data={positionData}
                isWorkWithRealtime={false}
                isCleanEnabled={false}
                minChoice={1}
                isDisabled={disabled}
                maxChoice={1}
                isMultipleSelect={false}
                onOk={(
                    selectedItems
                ) => {
                    if(selectedItems && selectedItems.length) {
                        const positionID = selectedItems[0]?.__key;

                        if(!updateParams) {

                            setUpdateParams({
                                companies: [
                                    {
                                        companyID: companyID,
                                        positionID: positionID as string
                                    }
                                ]
                            });
                            return;
                        }

                        const _updateParams: SendProfileUpdateRequestRequestType = JSON.parse(JSON.stringify(updateParams));

                        if(_updateParams.companies && _updateParams.companies.length && positionID) {
                            const _index =  _updateParams.companies.findIndex(e => e.companyID === companyID);
                            if(_index !== -1 ){
                                _updateParams.companies[_index] = {
                                    companyID: companyID,
                                    positionID: positionID
                                };
                            } else  {
                                _updateParams.companies.push({
                                    positionID: positionID as string,
                                    companyID: companyID
                                });
                            }
                        } else {
                            _updateParams.companies = [
                                {
                                    companyID: companyID,
                                    positionID: positionID as string
                                }
                            ];
                        }

                        setUpdateParams(_updateParams);
                    }
                }}
            />
        </View>
    </View>;
};
export default PositionCard;
